import { getOffEvtList } from '@/services/operations/event';
import { EVENT_QUERY_KEYS } from '@/services/query-keys/event';
import { useQuery } from '@tanstack/react-query';

export const useOffEvtListQuery = () => {
    return useQuery({
        queryKey: EVENT_QUERY_KEYS.offEvtList(),
        queryFn: async () => {
            const response = await getOffEvtList();
            if (!response.ok || !response.data) {
                throw new Error('Failed to fetch event list');
            }
            return response.data;
        },
    });
};
